import React from "react";

const PricingHero: React.FC = () => {
  return (
    <section className="pp-hero lr-grain">
      <div className="pp-hero__orbs">
        <div className="pp-hero__orb pp-hero__orb--1" />
        <div className="pp-hero__orb pp-hero__orb--2" />
      </div>

      <div className="pp-hero__content">
        <span className="pp-hero__badge">
          <span />
          Subscription plans
        </span>
        <h1 className="pp-hero__title">
          <span className="lr-hero-word" style={{ animationDelay: "0.05s" }}>
            <span className="lr-text-gradient">Choose the plan</span>
          </span>{" "}
          <span className="lr-hero-word" style={{ animationDelay: "0.2s" }}>
            <span className="lr-text-gradient">that works</span>
          </span>{" "}
          <span className="lr-hero-word" style={{ animationDelay: "0.35s" }}>
            <span className="lr-text-gradient">for you.</span>
          </span>
        </h1>
        <p className="pp-hero__subtitle">Simple pricing. No hidden fees. Cancel anytime.</p>
      </div>
    </section>
  );
};

export default PricingHero;
